var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "#DB000C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4023 29.2441C11.793 29.2441 12.0664 29.0488 12.5254 28.6191L15.3672 25.9727C14.8203 25.5332 14.3711 24.8398 14.3711 23.248V16.7734C14.3711 13.7852 16.1875 11.998 19.1855 11.998H26.0215L26.0117 11.6367C25.8652 9.625 24.5469 8.32617 22.3105 8.32617H8.91211C6.67578 8.32617 5.20117 9.66406 5.20117 11.998V21.5879C5.20117 23.9023 6.67578 25.3965 8.91211 25.3965H10.5332V28.248C10.5332 28.8438 10.8555 29.2441 11.4023 29.2441ZM27.1836 30.5918C27.7402 30.5918 28.0527 30.2012 28.0527 29.5957V26.7539H29.0879C31.3242 26.7539 32.7988 25.2598 32.7988 22.9355V16.998C32.7988 14.6738 31.3242 13.3359 29.0879 13.3359H19.4102C17.0762 13.3359 15.709 14.6738 15.709 17.0078V22.9355C15.709 25.2598 17.0762 26.7539 19.4102 26.7539H22.5352L26.0605 29.9766C26.5195 30.3965 26.793 30.5918 27.1836 30.5918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.34c64fd629be5c74977da78d2bf054cf.svg";
export { ForwardRef as ReactComponent };